
import { actionType } from "../footer/action";
import { put, takeEvery } from 'redux-saga/effects';
import common from "../../assets/lang/jp/common";
import { config }  from "../../config";
function* fetchFooter() {
  yield put({ type: actionType.FOOTER_MENUS_RECEIVED, payload: (config.env !=='localhost') ? common[config.env].footer :  common.footer });
}
export const FooterSagas = [
  takeEvery(actionType.GET_FOOTER_MENUS, fetchFooter)
] 